<template>
  <DialogLayout
    :title="title"
    :visible.sync="dialogVisible"
    width="45em"
    @open="open"
  >
    <template #form>
      <CreateForm
        ref="createForm"
        v-model="createFormModel"
        action="/create-merge-data"
        billingYmMode="this"
      />
    </template>
    <template #footer>
      <CreateDialogFooter
        @create="clickCreate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import CreateForm from '@/components/organisms/dialog/CreateForm.vue'
import CreateDialogFooter from '@/components/organisms/dialog/CreateDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    CreateForm,
    CreateDialogFooter
  },
  mixins: [
  ],
  props: {
    visible: Boolean
  },
  data () {
    return {
      title: 'データ作成',
      createFormModel: {
        billing_ym: this.getDefaultBillingYm()
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickCreate () {
      if (!(await this.$fcMessage.messageBox(this.title, 'DTM0001W'))) {
        return
      }

      this.$loadingMask.on()
      const params = { ...this.createFormModel }
      this.$refs.createForm.validate()
        .then((valid) => {
          return this.$axios.get('/count-hangar-usages-data', { params: params })
        })
        .then((res) => {
          if (res.data.list[0].hangar_usages_count === 0) {
            return this.continueConfirm(res)
          }
          return Promise.resolve(res)
        })
        .then((res) => {
          return this.$axios.post('/create-merge-data', params)
        })
        .then((res) => {
          if (res.status === 202) {
            this.$fcMessage.showMessage({
              id: 'DTM0001I',
              link: {
                fileName: 'warning.txt',
                messages: res.data.message
              }
            }, true)
          } else {
            this.$fcMessage.showMessage(res.data.message)
          }
          this.dialogVisible = false
          this.$emit('refresh', this.createFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              case 404:
                this.$fcMessage.showMessage({
                  id: 'DTM0002E',
                  link: {
                    fileName: 'error.txt',
                    messages: e.response.data.message
                  }
                }, true)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    async continueConfirm (res) {
      if (!(await this.$fcMessage.messageBox(this.title, 'DTM0002W'))) {
        return Promise.reject(new Error('cancel'))
      }
      return Promise.resolve(res)
    },
    open () {
      this.$nextTick(function () {
        this.$refs.createForm.clear()
      })
    }
  }
}
</script>

<style lang="scss">
    // 実績年月の表示追加
    .el-form-item{
    white-space: nowrap;
  }
</style>
